import { ColumnMapping, ExcelProcessorConfig, HeaderConfig, ParsedExcelData, ValidationError } from '@/lib/excel';

export const HEADERS = {
  DVT: 'Đơn vị tính*',
  TEN_DVT: 'Tên đvt*',
  TEN_KHAC: 'Tên khác',
  DVT2: 'Đơn vị tính 2'
} as const;

export interface ImportBody {
  dvt: string;
  ten_dvt: string;
  ten_khac?: string | null;
  dvt2?: string | null;
  status: number;
}

const HEADER_CONFIG: HeaderConfig[] = [
  { header: HEADERS.DVT, key: 'dvt', type: 'main' },
  { header: HEADERS.TEN_DVT, key: 'ten_dvt', type: 'main' },
  { header: HEADERS.TEN_KHAC, key: 'ten_khac', type: 'main' },
  { header: HEADERS.DVT2, key: 'dvt2', type: 'main' }
];

const toStringOrNull = (value: unknown): string | null => {
  if (value === null || value === undefined) return null;
  const str = String(value).trim();
  return str === '' ? null : str;
};

const UUIDPayload = (parsedData: ParsedExcelData) => {
  return {
    main: {}
  };
};

const ValidateUUID = (response: unknown, columnMapping: Record<string, ColumnMapping>): ValidationError[] => {
  return [];
};

const TransformToBodies = (
  dataRows: unknown[][],
  parsedData: ParsedExcelData,
  UUIDResponse: unknown,
  context: unknown
): ImportBody[] => {
  const mainData = parsedData.main || {};
  const rowCount = (mainData.dvt || []).length;
  const bodies: ImportBody[] = [];

  for (let i = 0; i < rowCount; i++) {
    const body: ImportBody = {
      dvt: toStringOrNull(mainData.dvt?.[i] ?? '') || '',
      ten_dvt: toStringOrNull(mainData.ten_dvt?.[i] ?? '') || '',
      ten_khac: toStringOrNull(mainData.ten_khac?.[i] ?? ''),
      dvt2: toStringOrNull(mainData.dvt2?.[i] ?? ''),
      status: 1
    };
    bodies.push(body);
  }

  return bodies;
};

export const ExcelConfig: ExcelProcessorConfig<ImportBody> = {
  Headers: HEADERS,
  HeaderConfig: HEADER_CONFIG,
  Transform: TransformToBodies,
  UUIDPayload,
  ValidateUUID
};
